module.exports = __webpack_public_path__ + "img/27_68.ec2fbd1b.png";